import { RoleAction } from "src/Api/Enum/Role";
import { TableName } from "../table";
import type { CustomerPermission, TablePermission } from "./permission";
import {
  PermissionFactory,
  CRUD,
  VIEW_ONLY
} from "./permission";

export const analystPermission = (
  customerPermissions: CustomerPermission[] = [],
  userRoles: string[] = [],
): TablePermission => ({
  [TableName.ViewPom]: VIEW_ONLY,

  [TableName.DisplayPom]: VIEW_ONLY,

  [TableName.Profile]: VIEW_ONLY,

  [TableName.ViewWelcomePage]: [
    PermissionFactory.buildPermission(RoleAction.VIEW),
    PermissionFactory.buildPermission(RoleAction.VIEW_OVERVIEW),
    PermissionFactory.buildFeaturePermission(
      RoleAction.SUMMARY_REPORT, "SUMMARY_REPORT", customerPermissions, userRoles
    ),
  ],

  [TableName.Category]: VIEW_ONLY,

  [TableName.MapLocation]: VIEW_ONLY,

  [TableName.ChangePassword]: VIEW_ONLY,

  [TableName.Ticketing]: [
    PermissionFactory.buildFeaturePermission(
      RoleAction.VIEW, "TICKETING", customerPermissions, userRoles
    ),
    PermissionFactory.buildFeaturePermission(
      RoleAction.CREATE, "TICKETING", customerPermissions, userRoles
    ),
    PermissionFactory.buildPermission(RoleAction.DIFFERENT_CUSTOMER_POM),
  ],

  [TableName.LegalInfo]: [
    PermissionFactory.buildFeaturePermission(
      RoleAction.VIEW, "PRIVACY_SECTION", customerPermissions, userRoles
    ),
  ],
  [TableName.LocationStatus]: VIEW_ONLY,
  [TableName.Impersonation]: [
    PermissionFactory.buildPermission(RoleAction.IMPERSONATION),
  ],
  [TableName.DisplayView]: [
    ...CRUD,
    PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_USER),
    PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_GROUP),
    PermissionFactory.buildFeaturePermission(
      RoleAction.DELETE_VIEW_ADVANCED, "DELETE_VIEW_ADVANCED", customerPermissions, userRoles
    ),
  ],
});